<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="ch01">
<h1 class="ct"><a class="xref" href="#/wsuridl0007#rch01">Likely</a></h1>
<div class="senseline">
<p class="sl">Most days come</p>
<p class="sl">along like a child</p>
<p class="sl">kicking a stone</p>
<p class="slf">down an alley</p>
<p class="sl">or like the way</p>
<p class="sl">the mail lies</p>
<p class="slf">in the mailbox,</p>
<p class="sl">its flag up. But</p>
<p class="sl">sometimes as</p>
<p class="slf">you wander into</p>
<p class="sl">some old words,</p>
<p class="sl">you feel yourself</p>
<p class="slf">gliding on the morning,</p>
<p class="sl">maybe looking back</p>
<p class="sl">over your shoulder.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-ridl-0008.vue?66505864